import { Box, Grid } from "@mui/material";
import AccountStatsGrid from "shared/components/projectHeadComponents/dashboard/accountsStatsGrid";
import AdminRequests from "shared/components/projectHeadComponents/dashboard/adminRequests";
import AnalyticalGrid from "shared/components/projectHeadComponents/dashboard/analyticsGrid";
import EarningGrid from "shared/components/projectHeadComponents/dashboard/earningGrid";
import PendingTask from "shared/components/projectHeadComponents/dashboard/pendingTaskGrid";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";

function DashboardHeadNew() {
  useBreadcrumbs({
    title: "Dashboard",
    path: routeConstant?.dashboard?.path,
  });

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.headingContainer}>
        <span className={styles.heading}>Good Afternoon Sir -</span>
        <span className={styles.heading1}>here's what's happening today</span>
      </Box>
      <Grid container className={styles.mainGrid} spacing={2}>
        <Grid xs={12} lg={8} item>
          <AnalyticalGrid />
        </Grid>
        <Grid xs={12} lg={4} item>
          <AccountStatsGrid />
        </Grid>
      </Grid>

      <Grid container className={styles.mainGrid} spacing={2}>
        <Grid xs={12} lg={7} item>
          <PendingTask />
        </Grid>
        <Grid xs={12} lg={5} item>
          <EarningGrid />
          <AdminRequests />
        </Grid>
      </Grid>
    </div>
  );
}

export default DashboardHeadNew;
